// extracted by mini-css-extract-plugin
export default {"wrapper":"ComingSoon_wrapper__6PuAT","surface":"ComingSoon_surface__+aEYK","pill":"ComingSoon_pill__C+rOr"};